import { RTO_REGEX, SIGNALR_PROPS, SIGNALR_STATUS } from "./constants";

export const validateVehicleNumber = (value) => {
    if(RTO_REGEX.find ((regex) => value.match(regex) ? true : false)) 
        return true
    else
        return false;
}

export const initAnalytics = () => {
    let analytics = {};
    const signalR = {...SIGNALR_PROPS, ...SIGNALR_STATUS};
    for (const key in signalR)
        analytics[signalR[key]] = 0;
    return analytics;
}